import React, { Fragment } from "react"
import Layout from "../../../components/layout/layout"
import directionsContent from "../../../components/hut-data/hut4/directions"
import hutFictionContent from "../../../components/hut-data/hut4/hutFiction"
import aboutContent from "../../../components/hut-data/hut4/about"
import HutPageLayout from "../../../components/hutPageLayout/hutPageLayout"
import HutMap from "../../../components/hutMap/hutMap"
import { AccordionContent } from "../../../components/accordion/accordion"
import { GeolocationContext } from "../../../AppState"
import hutTitle from "../../../components/hut-data/hut4/hut-title.svg"
import doodle from "../../../components/hut-data/hut4/hut-doodle.jpg"
import aboutImg from "../../../components/hut-data/hut4/about-img.jpg"

const accordionContent: AccordionContent[] = [
  {
    title: "Directions",
    inner: (
      <Fragment>
        <img src={doodle} className="width-full" alt="" />
        <div className="u-side-pad u-top-pad">{directionsContent}</div>
      </Fragment>
    ),
    backgroundColour: "#fae297",
  },
  {
    title: "Found it",
    inner: "",
    backgroundColour: "#ffcc99",
  },
  {
    title: "Hut fiction",
    inner: hutFictionContent,
    backgroundColour: "#d0dce2",
    locked: true,
  },
  {
    title: "About",
    inner: (
      <Fragment>
        <img src={aboutImg} alt="" className="width-full" />
        {aboutContent}
      </Fragment>
    ),
  },
]
function Hut() {
  return (
    <Layout title="Ōtaki hut">
      <GeolocationContext.Consumer>
        {context => {
          const { foundHuts } = context
          return (
            <div className="map__info-container">
              <HutMap
                isHutPage
                height="320px"
                foundHuts={foundHuts}
                bounds={[
                  [175.1118106078393, -40.728602147732765],
                  [175.1263388082582, -40.73542176311948],
                ]}
              />
            </div>
          )
        }}
      </GeolocationContext.Consumer>
      <HutPageLayout
        hutId="hut4"
        heading="Ōtaki hut"
        headingImg={hutTitle}
        headingColour="#e53887"
        description="We create our world together from what we have around us. What does this hut need that you can give?"
        accordionContent={accordionContent}
        unlockCode="DUN3BUG"
      />
    </Layout>
  )
}

export default Hut
